import { render } from "./ProductTypeList.vue?vue&type=template&id=de49874a&scoped=true"
import script from "./ProductTypeList.vue?vue&type=script&lang=js"
export * from "./ProductTypeList.vue?vue&type=script&lang=js"

import "./ProductTypeList.vue?vue&type=style&index=0&id=de49874a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de49874a"]])

export default __exports__